import { isSsr } from './DetectSSR';

export default {
  methods: {
    // detect if it's the ssr side
    isSsr: () => isSsr(),
  },
};
